<template>
    <v-main>
        <v-container fill-height fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="4">
                    <h1 class="text-center">TC Deliveries CMS</h1>
                    <h5 class="text-center mb-4">v{{ $store.state.app.version }}</h5>
                    <v-card class="elevation-12">
                        <v-toolbar color="primary" dark>
                            <v-toolbar-title>Login</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-form v-model="isFormValid">
                                <v-text-field
                                    autofocus
                                    label="Username"
                                    name="username"
                                    type="text"
                                    v-model="credentials.username"
                                    v-bind:rules="validation.usernameRules"
                                    required
                                    prepend-icon="mdi-account"
                                ></v-text-field>
                                <v-text-field
                                    label="Password"
                                    name="password"
                                    v-model="credentials.password"
                                    v-bind:rules="validation.passwordRules"
                                    required
                                    prepend-icon="mdi-lock"
                                    v-bind:append-icon="
                                        shouldShowPassword
                                            ? 'mdi-eye-off'
                                            : 'mdi-eye'
                                    "
                                    v-bind:type="
                                        shouldShowPassword ? 'text' : 'password'
                                    "
                                    v-on:click:append="
                                        () =>
                                            (shouldShowPassword = !shouldShowPassword)
                                    "
                                    v-on:keydown.enter="submit"
                                ></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="primary"
                                class="ma-4 px-6 py-2"
                                v-on:click="submit"
                                v-bind:disabled="isSubmitting || !isFormValid"
                                v-bind:loading="isSubmitting"
                            >
                                Login
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
import { mapActions } from 'vuex';
import roleUtil from '@/utils/roleUtil';
import snackbar from '@/utils/snackbar';

export default {
    data() {
        return {
            credentials: {
                username: '',
                password: ''
            },
            shouldShowPassword: false,
            isFormValid: false,
            isSubmitting: false,
            validation: {
                usernameRules: [v => !!v || 'Username is required'],
                passwordRules: [v => !!v || 'Password is required']
            }
        };
    },

    methods: {
        ...mapActions({
            login: 'auth/login'
        }),

        async submit() {
            if (this.isSubmitting || !this.isFormValid) {
                return;
            }

            this.isSubmitting = true;

            try {
                const user = await this.login(this.credentials);
                snackbar.show('Logged in', 'success');
                this.$log.info('Logged in:', user.username);
                this.$router.push(roleUtil.getRoleHome(user));
            } finally {
                this.isSubmitting = false;
            }
        }
    }
};
</script>
